import * as Sentry from "@sentry/react";
import { Outlet } from "react-router-dom";
import { SidebarProvider, SidebarInset, Toaster } from "@athena/ui";
import { AppSidebar } from "@/components/AppSidebar";
import { ErrorFallback } from "@/components/ErrorFallback";

export function CourseLayout() {
    return (
        <SidebarProvider>
            <AppSidebar />
            <SidebarInset>
                <main className="flex flex-col">
                    <Sentry.ErrorBoundary
                        fallback={({ error, resetError }) => <ErrorFallback error={error} resetError={resetError} />}
                    >
                        <Outlet />
                        <Toaster />
                    </Sentry.ErrorBoundary>
                </main>
            </SidebarInset>
        </SidebarProvider>
    );
}
